class GTM {
    init() {
        var t = this;
		var body = document.body;
		window.dataLayer = window.dataLayer || [];
        if( body.classList.contains('woocommerce-order-received') ) {
			t.purchase( document.querySelector('.woocommerce-order-overview__order strong').textContent );
			t.transaction( document.querySelector('.woocommerce-order-overview__order strong').textContent );
		}
        if( body.classList.contains('woocommerce-checkout') && !body.classList.contains('woocommerce-order-received') ) {
			t.beginCheckout();
		}
    }
    getThemeName() {
		let body = document.body;
		let themeName = null;
		body.getAttribute('class').split(' ').forEach( function( single,index ) {
			if( single.indexOf('theme-') >= 0 ) {
				themeName = single.split('-')[1];
			}
		});
		return themeName;
	}
    addToCart( itemID, quantity = 1 ) {

		let t = this;
		let request = new XMLHttpRequest();
		let response;

		request.onreadystatechange = function() {

			if( request.responseText && request.readyState == 4 && request.status == 200 ) {

				response = JSON.parse(request.responseText);

				if( response.status == 'success' ) {
                    
                    response.json.conversionvalue = ( parseFloat(response.json.value) * 0.1).toString();

					dataLayer.push({
						'event' : 'add_to_cart',
						'ecommerce' : response.json
					});

				}

			}

		}

		// Set up our request
		request.open('POST', window.location.origin+'/wp-content/themes/'+t.getThemeName()+'/src/Components/GTM/GetSingleItem.php' );

		// Add the required HTTP header for form data POST requests
		request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

		// Finally, send our data.
		request.send('itemID='+itemID+'&quantity='+quantity);

	}
    beginCheckout() {

		let t = this;
		let request = new XMLHttpRequest();
		let response;

		request.onreadystatechange = function() {

			if( request.responseText && request.readyState == 4 && request.status == 200 ) {

				response = JSON.parse(request.responseText);

				if( response.status == 'success' ) {
                    
                    response.json.conversionvalue = ( parseFloat(response.json.value) * 0.2).toString();
					dataLayer.push({
						'event' : 'begin_checkout',
						'ecommerce' : response.json
					});

				}

			}

		}

		// Set up our request
		request.open('POST', window.location.origin+'/wp-content/themes/'+t.getThemeName()+'/src/Components/GTM/GetCartCheckout.php' );

		// Add the required HTTP header for form data POST requests
		request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

		// Finally, send our data.
		request.send();

	}
    purchase( orderID ) {
		let t = this;
		let request = new XMLHttpRequest();
		let response;
		request.onreadystatechange = function() {

			if( request.responseText && request.readyState == 4 && request.status == 200 ) {

				response = JSON.parse(request.responseText);

				if( response.status == 'success' ) {

                    response.json.conversionvalue = ( parseFloat(response.json.value) * 0.7).toString();
					// dataLayer.push({
					// 	'event' : 'purchase',
					// 	'ecommerce' : response.json
					// });

				}

			}

		}
		// Set up our request
		request.open('POST', window.location.origin+'/wp-content/themes/'+t.getThemeName()+'/src/Components/GTM/GetPurchase.php' );
		// Add the required HTTP header for form data POST requests
		request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		// Finally, send our data.
		request.send('orderID='+orderID);
	}
    transaction( orderID ) {
		let t = this;
		let request = new XMLHttpRequest();
		let response;

		request.onreadystatechange = function() {

			if( request.responseText && request.readyState == 4 && request.status == 200 ) {

				response = JSON.parse(request.responseText);
				if( response.status == 'success' ) {
                    
					dataLayer.push(response.json);
					// wysyłane zdarzenie w celu przechwycenia zdarzenia transakcji
					dataLayer.push({
						'event' : 'purchase-gaua',
					});

				}

			}

		}

		// Set up our request
		request.open('POST', window.location.origin+'/wp-content/themes/'+t.getThemeName()+'/src/Components/GTM/GetTransaction.php' );

		// Add the required HTTP header for form data POST requests
		request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

		// Finally, send our data.
		request.send('orderID='+orderID);
	}

}
export default GTM;